import {Component, Input, NgZone} from '@angular/core';
import {MenuController} from "@ionic/angular";
import {AuthService, IdToken} from "@auth0/auth0-angular";

@Component({
    selector: 'app-header-list',
    templateUrl: './edicao.component.html',
    styleUrls: ['./edicao.component.scss']
})
export class HeaderListComponent {
    @Input()
    titulo: string = ""

  token?: IdToken

  constructor(private menuCtrl: MenuController, private auth: AuthService) {
    const raw_token = localStorage.getItem("token")
    if(raw_token)
      this.token =  JSON.parse(raw_token!!) as IdToken
  }
  menuDireito(){
      this.menuCtrl.open('end')
  }

  get agencia(): string|undefined {
      return this.token ? this.token['agencia'] : ''
  }

  logout(){
      alert('vai fechar')
    localStorage.removeItem("token")
    this.auth.logout()
    location.reload()
  }
}
